module.exports = {
          srcSet: __webpack_public_path__ + "1848949145938d00aa605b9ea05c4d0a-91.png"+" 91w",
          images:[ {path: __webpack_public_path__ + "1848949145938d00aa605b9ea05c4d0a-91.png",width: 91,height: 91}],
          src: __webpack_public_path__ + "1848949145938d00aa605b9ea05c4d0a-91.png",
          toString:function(){return __webpack_public_path__ + "1848949145938d00aa605b9ea05c4d0a-91.png"},
          
          width: 91,
          height: 91
        }